import { SystemConfigurations } from '@factorin/domain';

import { get, put, withUrl, Request } from '../rest';


const systemConfigurationPart = withUrl('systemConfiguration');

export const systemConfiguration = {
    list: get<void, SystemConfigurations.SystemConfiguration[]>(
        () => systemConfigurationPart(),
    ),
    put: put<Request.Body, void>(
        ({ body }) => systemConfigurationPart({
            body,
        }),
    ),
};
